import { BaseModel, RecursivePartial } from '@models/base';

export class VzParamOldTplvar extends BaseModel {
    id?: string;
    name?: string;
    refId?: string;

    constructor(json?: RecursivePartial<VzParamOldTplvar>) {
        super(json);
        this.parseVzParamTplvar(json || {});
    }

    parse(json: RecursivePartial<VzParamOldTplvar>): VzParamOldTplvar {
        super.parse(json);
        this.parseVzParamTplvar(json);
        return this;
    }

    private parseVzParamTplvar(json: RecursivePartial<VzParamOldTplvar>): void {
        VzParamOldTplvar.assignFields<VzParamOldTplvar>(this, json, ['id', 'name', 'refId']);
    }
}
